import classNames from 'classnames'
import React from 'react'
import { useTranslation } from 'react-i18next'

import AppleIcon from '../assets/icons/apple.svg'
import GoogleIcon from '../assets/icons/google.svg'

interface OAuthButtonProps {
  provider: 'google' | 'apple'
  onClick?: () => void
  block?: boolean
  disabled?: boolean
}

const providerMetaMap: Record<OAuthButtonProps['provider'], { label: string; icon: string }> = {
  google: { label: 'Google', icon: GoogleIcon },
  apple: { label: 'Apple', icon: AppleIcon }
}

export const OAuthButton: React.FC<OAuthButtonProps> = ({ provider, onClick, block, disabled }) => {
  const { label, icon } = providerMetaMap[provider]
  const { t } = useTranslation()

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={classNames([
        'rounded-full min-h-[52px] border border-neutralBlack-200 hover:bg-neutralBlack-50 px-6 cursor-pointer flex items-center gap-2.5 justify-center text-[14.5px] font-medium disabled:opacity-50 disabled:pointer-events-none transition-colors',
        {
          'w-full': block
        }
      ])}
    >
      <img src={icon} alt={provider} className="w-[17px] align-middle" />
      <span className="leading-none">
        {t('oAuthButton.labelPrefix', { ns: 'auth' })} {label}
      </span>
    </button>
  )
}
